import React from "react";
import { Modal, Button } from "react-bootstrap";

const LatencyModal = ({ show, onHide, countdown }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="border-0"></Modal.Header>
      <Modal.Body className="text-center">
        <div
          style={{
            display: "inline-block",
            background: "radial-gradient(circle, #111 50%, #222 100%)",
            borderRadius: "50%",
            padding: 20,
            width: 120,
            height: 120,
            position: "relative",
            boxShadow: "inset 0 0 5px #000",
          }}
        >
          <div
            style={{
              color: "limegreen",
              fontSize: 32,
              fontFamily: "'Courier New', monospace",
            }}
          >
            {countdown}
          </div>
          <div
            style={{
              color: "#ccc",
              fontSize: 12,
              fontFamily: "'Courier New', monospace",
            }}
          >
            SEC
          </div>
          <div
            style={{
              position: "absolute",
              top: 8,
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: 2,
            }}
          >
            {[...Array(5)].map((_, idx) => (
              <span
                key={idx}
                style={{
                  height: 6,
                  width: 4,
                  background: "limegreen",
                  borderRadius: 2,
                }}
              ></span>
            ))}
          </div>
        </div>
        <h2
          style={{
            marginTop: 20,
            fontSize: 20,
            fontWeight: "bold",
            color: "#333",
          }}
        >
          Latency Count
        </h2>
        <p style={{ color: "#666" }}>Please speak to continue.</p>
        {/* <Button
          onClick={onHide}
          variant="primary"
          style={{ backgroundColor: "#9B59B6", borderColor: "#9B59B6" }}
        >
          OK
        </Button> */}
      </Modal.Body>
    </Modal>
  );
};

export default LatencyModal;
